// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1_E1I","rootSuccess":"CompleteLink_rootSuccess__20NCZ","rootFailure":"CompleteLink_rootFailure__3IpFo","isDisabled":"CompleteLink_isDisabled__1Tzx_"};